export default [
  //algeria
  {
    project: 'ON SHORE LEDJMET BLOCK 405b CAF C GAS GATHERING',
    contractor: 'SH FCP - SONATRACH',
    finalClient: 'SH FCP - SONATRACH',
    destination: 'ALGERIA',
    supplyScope: 'FIELD INSTRUMENTS & PIPING BULK MATERIALS',
    value: 100,
    color: '#de4c4f',
    latitude: 31,
    longitude: 2,
  },
  {
    project: 'ON SHORE LEDJMET BLOCK 405b CAF C GAS GATHERING',
    contractor: 'SH FCP - SONATRACH',
    finalClient: 'SH FCP - SONATRACH',
    destination: 'ALGERIA',
    supplyScope: 'VALVES',
    value: 100,
    color: '#de4c4f',
    latitude: 30,
    longitude: 5,
  },
  {
    project: 'ON SHORE LEDJMET BLOCK 405b CAF C GAS GATHERING',
    contractor: 'SH FCP - SONATRACH',
    finalClient: 'SH FCP - SONATRACH',
    destination: 'ALGERIA',
    supplyScope: 'FIELD INSTRUMENTS AND SPARE PARTS',
    value: 100,
    color: '#de4c4f',
    latitude: 28,
    longitude: 2,
  },
  {
    project: 'CHAMPS BRN&ROD BLOCKS 401A & 402A',
    contractor: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    finalClient: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    destination: 'ALGERIA',
    supplyScope: 'FIELD INSTRUMENTS',
    value: 100,
    color: '#de4c4f',
    latitude: 26,
    longitude: 7,
  },
  {
    project: 'CHAMPS BRN&ROD BLOCKS 401A & 402A',
    contractor: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    finalClient: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    destination: 'ALGERIA',
    supplyScope: 'VALVES & PIPING BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 28.03,
    longitude: 5,
  },
  {
    project: 'MACARONI STRINGS REINTEGRATION PROGRAM',
    contractor: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    finalClient: 'GROUPEMENT SONATRACH-AGIP (GSA)',
    destination: 'ALGERIA',
    supplyScope: 'MACARONI STRINGS',
    value: 100,
    color: '#de4c4f',
    latitude: 26.5,
    longitude: 3.5,
  },
  //iraq
  {
    project: 'ZUBAIR',
    contractor: 'JURMAT GROUP – SHAMS AL SABAH',
    finalClient: 'ALSTOM-GE',
    destination: 'IRAQ',
    supplyScope: 'RAISED FLOOR SYSTEM',
    value: 100,
    color: '#de4c4f',
    latitude: 33.3128,
    longitude: 44.3614,
  },
  //egitto
  {
    project: 'ZOHR',
    contractor: 'ENPPI',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'EFW AND SEAMLESS PIPES',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 27.24,
  },
  {
    project: 'ZOHR',
    contractor: 'ENPPI',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'FITTINGS AND PIPING',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 28.24,
  },
  {
    project: 'ZOHR',
    contractor: 'ENPPI',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'INSTRUMENTATION AND ELECTRICAL MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 29.24,
  },
  {
    project: 'ZOHR',
    contractor: 'PETROJET',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'PIG TRAPS',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 31.24,
  },
  {
    project: 'NIDOCO NORTH WEST GAS DEVELOPMENT PROJECT',
    contractor: 'PETROBEL BELAYM PRETROLEUM - ENI',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'SUPPLY OF FLANGES',
    value: 100,
    color: '#de4c4f',
    latitude: 31.6,
    longitude: 31.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'PETROBEL BELAYM PRETROLEUM - ENI',
    finalClient: 'PETROBEL BELAYM PRETROLEUM - ENI',
    destination: 'EGYPT',
    supplyScope: 'FIELD INSTRUMENTS & PIPING BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 31.3,
    longitude: 30.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'BAPETCO (BADR PETROLEUM COMPANY)',
    finalClient: 'SHELL',
    destination: 'EGYPT',
    supplyScope: 'INSTRUMENTS & BULK MATERIALS',
    value: 100,
    color: '#de4c4f',
    latitude: 31.0,
    longitude: 28.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'BURULLUS',
    finalClient: 'BRITISH PETROLEUM',
    destination: 'EGYPT',
    supplyScope: 'BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 29.06,
    longitude: 26.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'IEOC',
    finalClient: 'IEOC',
    destination: 'EGYPT',
    supplyScope: 'UPS SUPPLY',
    value: 100,
    color: '#de4c4f',
    latitude: 29.06,
    longitude: 27.24,
  },
  {
    project: 'RAL EL BARR PROJECT',
    contractor: 'PHARAONIC PETROLEUM',
    finalClient: 'BRITISH PETROLEUM',
    destination: 'EGYPT',
    supplyScope: 'FIELD INSTRUMENTS & PIPING BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 25.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'BURULLUS',
    finalClient: 'BURULLUS',
    destination: 'EGYPT',
    supplyScope: 'SPARE PARTS',
    value: 100,
    color: '#de4c4f',
    latitude: 31.06,
    longitude: 27.24,
  },
  {
    project: 'UGDC LNG PLANT PORT SAID IMPROVEMENT',
    contractor: 'UNITED GAS AND DERIVATES (UGDC)',
    finalClient: 'ENI–BP-GASCO',
    destination: 'EGYPT',
    supplyScope: 'VALVES',
    value: 100,
    color: '#de4c4f',
    latitude: 29.06,
    longitude: 27.24,
  },
  {
    project: 'VARIOUS',
    contractor: 'PHARAONIC PETROLEUM',
    finalClient: 'BRITISH PETROLEUM',
    destination: 'EGYPT',
    supplyScope: 'SPARE PARTS',
    value: 100,
    color: '#de4c4f',
    latitude: 30.06,
    longitude: 31.24,
  },
  //congo
  {
    project: 'VARIOUS PLATFORMS',
    contractor: 'NUOVA O.M.A.',
    finalClient: 'ENI CONGO',
    destination: 'CONGO',
    supplyScope: 'PIPING BULK MATERIAL & VALVES',
    value: 100,
    color: '#de4c4f',
    latitude: -4.26,
    longitude: 12.8,
  },
  {
    project: 'AWA PALOUKOU',
    contractor: 'MEDIOR LTD',
    finalClient: 'ENI CONGO',
    destination: 'CONGO',
    supplyScope: 'FIELD INSTRUMENTS & PIPING BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: -5.26,
    longitude: 11.8,
  },
  {
    project: 'C23932 ENI CONGO KITINA & AEP',
    contractor: 'SAIPEM',
    finalClient: 'ENI CONGO',
    destination: 'CONGO',
    supplyScope: 'FIELD INSTRUMENTS',
    value: 100,
    color: '#de4c4f',
    latitude: -3.26,
    longitude: 14.24,
  },
  //tunisia
  {
    project: 'MAAMOURA & BARAKA',
    contractor: 'ENI TUNISIA B.V.',
    finalClient: 'ENI TUNISIA B.V.',
    destination: 'TUNISIA',
    supplyScope: 'FIELD INSTRUMENTS',
    value: 100,
    color: '#de4c4f',
    latitude: 35,
    longitude: 9,
  },
  {
    project: 'BIR BEN TARTAR EPF',
    contractor: 'MEDCO ENERGI INTERNATIONAL',
    finalClient: 'MEDCO ENERGI INTERNATIONAL',
    destination: 'TUNISIA',
    supplyScope: 'PIPING BULK MATERIAL',
    value: 100,
    color: '#de4c4f',
    latitude: 36,
    longitude: 10.16,
  },
  {
    project: 'ADAM ON SHORE',
    contractor: 'ENI TUNISIA B.V.',
    finalClient: 'ENI TUNISIA B.V.',
    destination: 'TUNISIA',
    supplyScope: 'PIPING BULK – FIELD INSTRUMENTS',
    value: 100,
    color: '#de4c4f',
    latitude: 36.81,
    longitude: 9,
  },
  {
    project: 'BARAKA PHASE II',
    contractor: 'ENI TUNISIA B.V.',
    finalClient: 'ENI TUNISIA B.V.',
    destination: 'TUNISIA',
    supplyScope: 'FIELD INSTRUMENTS',
    value: 100,
    color: '#de4c4f',
    latitude: 33,
    longitude: 9,
  },

  // kazakhstan (2013)
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'DIETSMANN LLP',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'PIPING BULK MATERIAL',
    value: 100,
    color: '#eea638',
    latitude: 51,
    longitude: 57.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'SEASTAR INTERNATIONAL LLP',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'ELECTRICAL BULK & INSTRUMENT BULK MATERIAL',
    value: 100,
    color: '#eea638',
    latitude: 46,
    longitude: 58,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'EUSEBI IMPIANTI',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'PIPING BULK MATERIAL & INSTRUMENT BULK',
    value: 100,
    color: '#eea638',
    latitude: 47.3,
    longitude: 53.9,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM (KATABATAN FILED)',
    contractor: 'CASPIAN LOGISTIC AND PROCUREMENT LLP',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'FIELD INSTRUMENTS',
    value: 100,
    color: '#eea638',
    latitude: 45.5,
    longitude: 56.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'PSN KAZSTROY JSC',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'VALVES & PIPING BULK MATERIAL',
    value: 100,
    color: '#eea638',
    latitude: 48.5,
    longitude: 51.6,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'ISKER CONSORTIUM',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'PIPING BULK MATERIAL & VALVES',
    value: 100,
    color: '#eea638',
    latitude: 46,
    longitude: 54.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'OZEN PORT PRODUCTION',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'INSTRUMENTS & PIPING BULK MATERIALS',
    value: 100,
    color: '#eea638',
    latitude: 47,
    longitude: 56.8,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM',
    contractor: 'SAIPEM KAZAKHSTAN BRANCH',
    finalClient: 'AGIP KCO',
    destination: 'KAZAKHSTAN',
    supplyScope: 'PIPING BULK MATERIALS',
    value: 100,
    color: '#eea638',
    latitude: 50,
    longitude: 55.4,
  },


  //kazakhstan (2016/2017)
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'EUSEBI IMPIANTI SRL',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'INSTRUMENTAL BULK & SAMPLING SKIDS',
    value: 100,
    color: '#eea638',
    latitude: 47.7,
    longitude: 56.4,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'BERTRAMS HEATEC AG',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'VALVES',
    value: 100,
    color: '#eea638',
    latitude: 48,
    longitude: 57.6,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'ISKER CONSORTIUM LLP',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'INSTRUMENTAL BULK & CABLE TRAYS',
    value: 100,
    color: '#eea638',
    latitude: 49,
    longitude: 54.2,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'KELBURN ENGINEERING LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'VALVES',
    value: 100,
    color: '#eea638',
    latitude: 49,
    longitude: 53,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'PSN KAZSTROY JSC',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'INSTRUMENTAL, ELECTRICAL AND F&G MATERIAL',
    value: 100,
    color: '#eea638',
    latitude: 50,
    longitude: 56.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'PSN KAZSTROY JSC',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'HEAT EXCHANGER GASKETS',
    value: 100,
    color: '#eea638',
    latitude: 51,
    longitude: 53.5,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'GASKETS, BOLTS & SPARES',
    value: 100,
    color: '#eea638',
    latitude: 51,
    longitude: 54.7,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'SEASTAR INTERNATIONAL',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'BOLTS, NUTS, SCREW, WASHER',
    value: 100,
    color: '#eea638',
    latitude: 44,
    longitude: 52.56,
  },

  //new project
  {
    project: 'NEW PROJECT!',
    contractor: 'N/A',
    finalClient: 'N/A',
    destination: 'ATYRAU',
    supplyScope: 'N/A',
    value: 100,
    color: '#66ccff',
    latitude: 47.07,
    longitude: 52.53,
  },
  //old kazakhstan (2015/2016)
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'PSN KAZSTROY JSC',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'VALVES',
    value: 100,
    color: '#eea638',
    latitude: 44.2,
    longitude: 54.5,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'INSTRUMENTAL & FIBER OPTIC CABLES',
    value: 100,
    color: '#eea638',
    latitude: 48,
    longitude: 54.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'GATE, GLOBE, CHECK & BUTTERFLY VALVES',
    value: 100,
    color: '#eea638',
    latitude: 46,
    longitude: 53.3,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'BALL & DBB VALVES',
    value: 100,
    color: '#eea638',
    latitude: 45,
    longitude: 55,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'FLOW TRANSMITTERS',
    value: 100,
    color: '#eea638',
    latitude: 44,
    longitude: 56,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'CORIOLIS FLOWMETERS',
    value: 100,
    color: '#eea638',
    latitude: 48.3,
    longitude: 56,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'SILENCERS',
    value: 100,
    color: '#eea638',
    latitude: 48,
    longitude: 58.6,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'GASKETS',
    value: 100,
    color: '#eea638',
    latitude: 43,
    longitude: 54.5,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'VALVES',
    value: 100,
    color: '#eea638',
    latitude: 43,
    longitude: 52,
  },
  {
    project: 'KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT',
    contractor: 'WORLEYPARSONS LTD',
    finalClient: 'NCOC (Ex AGIP KCO)',
    destination: 'KAZAKHSTAN',
    supplyScope: 'PRESSURE TRANSMITTERS',
    value: 100,
    color: '#eea638',
    latitude: 50,
    longitude: 53,
  },
  //italy
  {
    project: 'N/A',
    contractor: 'SAIPEM SPA',
    finalClient: 'SAIPEM SPA',
    destination: 'ITALY',
    supplyScope: 'PROCUREMENT SERVICES',
    value: 100,
    color: '#d8854f',
    latitude: 45.4642,
    longitude: 9.1895,
  },
  {
    project: 'AQUILA PHASE 2',
    contractor: 'SAIPEM SPA',
    finalClient: 'ENI SPA',
    destination: 'ITALY',
    supplyScope: 'PIPING BULK MATERIAL',
    value: 100,
    color: '#d8854f',
    latitude: 42.3505,
    longitude: 13.3995,
  },
  //venezuela
  {
    project: 'PERLA',
    contractor: 'CARDON IV',
    finalClient: 'CARDON IV',
    destination: 'VENEZUELA',
    supplyScope: 'MATERIAL FOR FLOWLINES',
    value: 100,
    color: '#86a965',
    latitude: 8,
    longitude: -66,
  },
  {
    project: 'PERLA',
    contractor: 'NAPEA INTERNATIONAL INC',
    finalClient: 'CARDON IV',
    destination: 'VENEZUELA',
    supplyScope: 'SUPPLY OF PIPE MATERIAL',
    value: 100,
    color: '#86a965',
    latitude: 8,
    longitude: -60,
  }
]



// WEBPACK FOOTER //
// ./src/data/projects.js